export const contactsData = {
    email: 'shahariar.rijon@gmail.com',
    phone: '+88014xxxxxxxx',
    address: 'Chittagong, Bangladesh-4214',

    sheetAPI: 'https://sheetdb.io/api/v1/zstt5kd177v38'
}